/*=============================================== BreadcrumbsPage ===============================================*/

import { Breadcrumbs } from "tsx-library-julseb"
import type { BreadcrumbsItemProps } from "tsx-library-julseb/types"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, iconBoxicon, propHref, propTo } from "data"

const BreadcrumbsPage = () => {
    const breadcrumbsItems: BreadcrumbsItemProps[] = [
        {
            text: "Link",
            to: "/",
        },
        {
            text: "Link",
            to: "#",
        },
        {
            text: "Link",
            to: "#",
        },
        {
            text: "Active",
        },
    ]

    const items: ItemType[] = [
        {
            intro: "",
            content: <Breadcrumbs items={breadcrumbsItems} />,
            code: 'const breadcrumbsItems = [\n    {\n        text: "Link",\n        to: "/",\n    },\n    {\n        text: "Link",\n        to: "#",\n    },\n    {\n        text: "Link",\n        to: "#",\n    },\n    {\n        text: "Active",\n    },\n]\n\n<Breadcrumbs items={breadcrumbsItems} />',
            codeTs: 'const breadcrumbsItems: BreadcrumbsItemProps[] = [\n    {\n        text: "Link",\n        to: "/",\n    },\n    {\n        text: "Link",\n        to: "#",\n    },\n    {\n        text: "Link",\n        to: "#",\n    },\n    {\n        text: "Active",\n    },\n]\n\n<Breadcrumbs items={breadcrumbsItems} />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            subtitle: "separator",
            type: "string",
            possible: ["slash", "icon"],
            default: (
                <>
                    <code>slash</code>, but if <code>separator</code> is set to{" "}
                    <code>icon</code>: {iconBoxicon("chevron-right")}
                </>
            ),
        },
        {
            subtitle: "customIcon",
            intro: (
                <>
                    Only if <code>separator</code> is not defined.{" "}
                    {commonProps.addIconCapital}
                </>
            ),
            type: "string",
        },
        "separator",
        {
            subtitle: "items",
            type: "array of objects",
            required: true,
        },
        {
            title: (
                <>
                    <code>item</code> object
                </>
            ),
            subtitle: "text",
            type: "string",
            required: true,
        },
        propTo,
        propHref,
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default BreadcrumbsPage
